<template>
  <button
    class="physical-links-button button button--text"
    type="button"
    @click="handleClickPhysicalLinks"
  >
    <span
      class="text-body-xs"
      v-text="$string('general.physical_links.change_location')"
    />
  </button>
</template>

<script>

/**
 * Vue: Physical links button (physical-links-button)
 * -----------------------------------------------------------------------------
 * Physical links button.
 *
 */
import { mapActions } from 'vuex'

export default {
  name: 'PhysicalLinksButton',

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
    }),

    /**
     * Handle click physical links button.
     */
    handleClickPhysicalLinks() {
      this.openOverlay({
        ignoreDismissed: true,
        namespace: 'physicalLinks',
      })
    },
  },
}
</script>
